import { render, staticRenderFns } from "./EventHistory.vue?vue&type=template&id=46f128fa&"
import script from "./EventHistory.vue?vue&type=script&lang=js&"
export * from "./EventHistory.vue?vue&type=script&lang=js&"
import style0 from "./EventHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports